/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import * as React from "react";
import { AxiosError } from "axios";
import { Trans } from "react-i18next";
import { extractServiceErrorCode } from "../../../../api/serviceErrorDeducer";
import { isAxiosError, isAxiosNetworkError, isAxiosServerError } from "../../../../api/errorDeducer";

interface Props {
  error: Error | AxiosError | null;
}

export default (props: Props) => {
  const { error } = props;
  if (!error) return null;

  if (isAxiosNetworkError(error)) {
    return <Trans i18nKey="CommonError.networkError">Cannot reach server. Please retry.</Trans>;
  }

  const errorCode = extractServiceErrorCode(error);
  if (errorCode) {
    switch (errorCode) {
      // Legal
      case 40037:
        return <Trans i18nKey="CommonError.LocalizedPolicy.InvalidParam">Invalid Localized Policy Parameter</Trans>;
      case 40038:
        return <Trans i18nKey="CommonError.LocalizedPolicy.NotFound">Policy Data Not Found</Trans>;
    }
  }

  const responseStatus = isAxiosError(error) && error.response && error.response.status;
  if (responseStatus === 403) {
    return <Trans i18nKey="CommonError.playerPortal.forbidden">You're not allowed</Trans>;
  }

  if (isAxiosServerError(error)) {
    return (
      <Trans i18nKey="CommonError.serverError">
        There is some technical issues with our site right now. Please try again later.
      </Trans>
    );
  }

  return <Trans i18nKey="CommonError.unknownError">Something went wrong. Please contact administrator.</Trans>;
};
